export default "__VITE_ASSET__DlJeMF6F__"